import React, { useCallback } from 'react';
import './styles.scss';
import { Jumbotron, Col, Row } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import {
  ArrowBackIos as ArrowBackIosIcon,
  Add as AddIcon,
  GetApp as GetAppIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { BaseText } from '..';

interface Props {
  title?: string;
  goBack?: {
    title: string;
    goBackPath: string;
  };
  onCreateClick?: () => void;
  onDownloadClick?: () => void;
  onUpdateClick?: () => void;
  onDeleteClick?: () => void;
}

const PagePath: React.FC<Props> = (props: Props) => {
  const {
    title,
    goBack,
    onCreateClick,
    onDownloadClick,
    onDeleteClick,
    onUpdateClick,
  } = props;
  const history = useHistory();

  const onNavigationClick = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history],
  );

  return (
    <Jumbotron className="page-path">
      <Row noGutters className="row-container">
        <Row noGutters className="left-container">
          {goBack && (
            <Button
              className="primary-button "
              onClick={() => onNavigationClick(goBack.goBackPath)}
            >
              <ArrowBackIosIcon fontSize="inherit" />
              {goBack.title}
            </Button>
          )}
          <BaseText.Heading>{title}</BaseText.Heading>
        </Row>
        <Col className="right-container">
          {onCreateClick && (
            <Button className="rounded-button create" onClick={onCreateClick}>
              <AddIcon fontSize="inherit" />
            </Button>
          )}
          {onDownloadClick && (
            <Button
              className="rounded-button download"
              onClick={onDownloadClick}
            >
              <GetAppIcon fontSize="inherit" />
            </Button>
          )}
          {onUpdateClick && (
            <Button className="rounded-button update" onClick={onUpdateClick}>
              <EditIcon fontSize="inherit" />
            </Button>
          )}
          {onDeleteClick && (
            <Button className="rounded-button delete" onClick={onDeleteClick}>
              <DeleteIcon fontSize="inherit" />
            </Button>
          )}
        </Col>
      </Row>
    </Jumbotron>
  );
};

export default PagePath;
